import { Router } from "express";

import { chatController } from "../controllers/chat-controller";
import { authenticate, createRateLimit } from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";
import { uploadChatFiles } from "../middleware/upload-middleware";

const router = Router();

// Environment-aware rate limiting
const generalRateLimit = createRateLimit.general();

/**
 * @route   POST /api/v1/chats
 * @desc    Create or get chat
 * @access  Private
 */
router.post("/", authenticate, generalRateLimit, (req, res) =>
  chatController.createOrGetChat(req, res),
);

/**
 * @route   GET /api/v1/chats
 * @desc    Get all chats for authenticated user
 * @access  Private
 */
router.get("/", authenticate, generalRateLimit, (req, res) =>
  chatController.getChats(req, res),
);

/**
 * @route   POST /api/v1/chats/student-admin
 * @desc    Create chat between student and admin
 * @access  Private (Student, Admin)
 */
router.post(
  "/student-admin",
  authenticate,
  requireRole(["student", "admin"]),
  generalRateLimit,
  (req, res) => chatController.createStudentAdminChat(req, res),
);

/**
 * @route   POST /api/v1/chats/teacher-school
 * @desc    Create chat between teacher and school
 * @access  Private (Teacher, School)
 */
router.post(
  "/teacher-school",
  authenticate,
  requireRole(["teacher", "school"]),
  generalRateLimit,
  (req, res) => chatController.createTeacherSchoolChat(req, res),
);

/**
 * @route   POST /api/v1/chats/school-admin
 * @desc    Create chat between school and admin
 * @access  Private (School, Admin)
 */
router.post(
  "/school-admin",
  authenticate,
  requireRole(["school", "admin"]),
  generalRateLimit,
  (req, res) => chatController.createSchoolAdminChat(req, res),
);

/**
 * @route   POST /api/v1/chats/group
 * @desc    Create group chat
 * @access  Private
 */
router.post("/group", authenticate, generalRateLimit, (req, res) =>
  chatController.createGroupChat(req, res),
);

/**
 * @route   GET /api/v1/chats/:chatId/messages
 * @desc    Get messages for a chat
 * @access  Private
 */
router.get("/:chatId/messages", authenticate, generalRateLimit, (req, res) =>
  chatController.getMessages(req, res),
);

/**
 * @route   POST /api/v1/chats/:chatId/messages
 * @desc    Send a message (with file upload support)
 * @access  Private
 */
router.post(
  "/:chatId/messages",
  authenticate,
  uploadChatFiles,
  generalRateLimit,
  (req, res) => chatController.sendMessage(req, res),
);

/**
 * @route   POST /api/v1/chats/:chatId/participants
 * @desc    Add participants to group chat
 * @access  Private
 */
router.post(
  "/:chatId/participants",
  authenticate,
  generalRateLimit,
  (req, res) => chatController.addParticipants(req, res),
);

/**
 * @route   DELETE /api/v1/chats/:chatId/participants/:participantId
 * @desc    Remove participant from group chat
 * @access  Private
 */
router.delete(
  "/:chatId/participants/:participantId",
  authenticate,
  generalRateLimit,
  (req, res) => chatController.removeParticipant(req, res),
);

/**
 * Student Query Routes
 */

/**
 * @route   POST /api/v1/student/queries
 * @desc    Create a student query (starts a chat)
 * @access  Private (Student)
 */
router.post(
  "/student/queries",
  authenticate,
  requireRole(["student"]),
  generalRateLimit,
  (req, res) => chatController.createQuery(req, res),
);

export default router;
